module.exports = __webpack_public_path__ + "img/zskf.b40d4315.png";